module.exports = __webpack_public_path__ + "assets/cff68d496f7ae699c002e054fcc89864.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/intro2.mp3
 ** module id = 356
 ** module chunks = 0
 **/